<template>
  <div>
    <h1 style="margin-left: 20px;margin-top: 15px;margin-bottom: 5px;">
      <v-icon
        style="margin-bottom:5px;font-size:30px; color: rgba(0, 0, 0, 0.87);"
      >
        mdi-poll
      </v-icon>{{ $t('menuType.poll') }}
    </h1>
    <v-container>
      <v-expansion-panels
        v-model="panel"
        focusable
      >
        <v-expansion-panel
          v-for="(item,i) in pollList"
          :key="i"
        >
          <v-expansion-panel-header>{{item.PollAlias}}</v-expansion-panel-header>
          <v-expansion-panel-content v-if="panel === i && pollList[i].responses">
            {{pollList[i].responses}}
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import * as sha1 from 'js-sha1'
  import api from '@/services/api'
  export default {
    data () {
      return {
        pollList: null,
        panel: null
      }
    },
    computed: {
      ...mapState('app',['enterpriseID']),
    },
    watch: {
      enterpriseID (newValue) {
        if (newValue) this.getPollList(newValue)
      },
      panel () {
        if(!this.pollList[this.panel].responses) {
          this.pollList[this.panel].responses = this.panel
        } else {
          alert(this.panel)
        }
      }
    },
    mounted() {
      console.log(this.getAuth('DOE101'))
    },
    methods: {
      getPollList (enterpriseID) {
        api.getAll(`enterprises/${enterpriseID}/poll-list`, 1, 10000).then(response => {
          console.log(response)
          this.pollList = response
          if (response.length > 0) this.panel = 0
        }).catch((error) => {
          console.log('error', error)
        })
      },
      getPollResponses () {
        
      },
      getAuth (value) {
        return sha1(value)
      }
    }
  }
</script>
